export default function (key) {
    const d = window.document;
    const s = d.createElement("script");
    s.id = "ze-snippet";
    s.src = `https://static.zdassets.com/ekr/snippet.js?key=${key}`;
    s.async = true;
    d.getElementsByTagName("head")[0].appendChild(s);

    return s;
}